import Extend from 'flarum/common/extenders';
import ContentComplaintPage from './components/ContentComplaintPage';
export default [new Extend.Routes().add('devconnect.content-complaints.form', '/report-content', ContentComplaintPage)];